import { VisibilityOff, Visibility } from "@mui/icons-material";
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, Button, Link, Alert, Collapse } from "@mui/material";
import PopupMessageComponent from "../popup-message/popup-message";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../../environment";
import { coreService } from "../../services/core.service";
import axios from "axios";
import ResetPasswordForm from "./reset-password-form";

const initialFormValues = {
    email: "",
};

const ForgotPasswordForm = (props: {setForgotPassword: Function}) => {
    const [formValues, setFormValues] = useState(initialFormValues);
    const [formSubmit, setFormSubmit] = useState(false);
    const [successOpen, setSuccessOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState({
        title: "",
        content: "",
    });

    const emptyForm = !formValues.email;

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        setFormSubmit(true);
        var params = new URLSearchParams({ email: formValues.email })
        axios({
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            url: `${apiUrl}/GenerateToken`,
            data: params.toString(),
        })
        .then((res) => {
            setFormSubmit(false);
            setSuccessOpen(true)
            setFormValues(initialFormValues);
        })
        .catch((error) => {
            setFormSubmit(false);
            setDialogMessage({
                title: "Error",
                content: "An error has occurred. Please try again.",
            });
            setDialogOpen(true);
        });
    };

    return (
        <>
            <Collapse in={!successOpen}>
                <div className="mb-4">Enter your email and we'll send you a token to reset your password</div>
                <form onSubmit={(e) => {handleSubmit(e)}}>
                    <FormControl fullWidth variant="outlined" className="">
                        <InputLabel htmlFor="outlined-adornment-password">Email</InputLabel>
                        <OutlinedInput name="email" type="text" value={formValues.email} onChange={handleInputChange} label="Email" />
                    </FormControl>
                    <Button className="w-100 mt-4" variant="contained" size="large" onClick={handleSubmit} disabled={emptyForm || formSubmit}>
                        Submit
                    </Button>
                </form>
                <div className="d-flex justify-content-between mt-4">
                    <Link className="cursor-pointer" color={'primary'} onClick={() => props.setForgotPassword(false)}><small>Return to Login</small></Link>
                    <Link className="cursor-pointer" color={'primary'} onClick={() => setSuccessOpen(true)}><small>Have a token?</small></Link>
                </div>

            </Collapse>
            <Collapse in={successOpen}>
                <ResetPasswordForm setSuccessOpen={setSuccessOpen} setForgotPassword={props.setForgotPassword}/>
            </Collapse>
            <PopupMessageComponent message={dialogMessage} open={dialogOpen} setOpen={setDialogOpen} />
        </>
    )
}

export default ForgotPasswordForm;